<template>
  <div>
    <b-alert class="alert_estimation" show style="margin-top: 30px"
      >L'estimation des temps intermédiaires est calculée à partir votre cotation <span v-if="type_estimation == 'itra'">ITRA</span><span v-else>Sportips</span> ainsi que du profil de course.</b-alert
    >
    <b-table id="table_passages_coureur" responsive small :tbody-tr-class="row_arrivee" :items="displayedPassage" :fields="fields">
      <template #cell(distance_depuis_depart)="row">
        <span v-if="row.item.distance_depuis_depart !== '' && row.item.distance_depuis_depart !== '0' && row.item.nom_affiche != 'Arrivée'">KM {{ Math.round(row.item.distance_depuis_depart) }}</span>
        <span v-else></span>
      </template>
      <template #cell(nom_affiche)="row">
        <b>{{ row.item.nom_affiche }}</b>
      </template>

      <template #cell(heure)="row">
        <span class="primary_color">Estimée {{ row.item.estimate }}*</span>
      </template>
      <template #cell(temps_intermediaire)="row">
        <span class="primary_color">Estimé {{ row.item.estimate_inter }}*</span>
      </template>
      <template #cell(temps_passage)="row">
        <span class="primary_color">Estimé {{ row.item.estimate_temps_course }}*</span>
      </template>
    </b-table>
    <hr />
  </div>
</template>

<script>
export default {
  props: ["passages", "coureur"],
  data() {
    return {
      fields: [
        {
          key: "distance_depuis_depart",
          sortable: false,
          label: "Distance",
        },
        {
          key: "nom_affiche",
          sortable: false,
          label: "Nom",
        },
        {
          key: "heure",
          sortable: false,
          label: this.$t("heure_passage"),
        },
        {
          key: "temps_intermediaire",
          sortable: false,
          label: this.$t("temps_inter"),
        },
        {
          key: "temps_passage",
          sortable: false,
          label: this.$t("temps_course"),
        },
      ],
    };
  },
  methods: {
    row_arrivee(item, type) {
      if (!item || type !== "row") return;
      if (item.nom.includes("Arrivée")) return "row-arrivee";
    },
  },
  computed: {
    displayedPassage() {
      var passages = [];
      if (this.passages.length > 1) {
        passages = this.passages;
        passages = passages.slice(1);
      }
      return passages;
    },
    type_estimation() {
      if (this.coureur.itra > 0) {
        return "itra";
      } else {
        return "sportips";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>